export async function hashString(subject: string): Promise<string | undefined> {
  try {
    const cleaned = subject.toLowerCase().trim();
    const encoded = new TextEncoder().encode(cleaned);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encoded);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  } catch {
    return undefined;
  }
}
